export default "__VITE_ASSET__DL2Hdj7P__"